import React, { FunctionComponent } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import { Auth } from '@justgiving/auth';
import { ExperimentContext } from '@justgiving/experiments';
import { ApolloClient, ApolloProvider } from '@apollo/client';

import App from '../../App';
import config, { AppFlags } from '../../client/config';
import { AuthContext } from '../../context/AuthContext';
import { FlagsProvider } from '../../context/FlagContext';
import { PageMetaContext, PageMetaContextProvider } from '../../context';
import { CustomOptimizelyProvider } from '../Optimizely/CustomOptimizelyProvider';
import { AnalyticsUserData } from '../../server/renderer';

type AppWithProvidersProps = {
  helmetProviderContext?: {};
  pageMetaContextProviderValue: PageMetaContext | null;
  apolloProviderClient: ApolloClient<any>;
  i18n: any;
  auth: Auth;
  flagOverrides?: Partial<AppFlags>;
  analyticsUserData: AnalyticsUserData;
};

const AppWithProviders: FunctionComponent<AppWithProvidersProps> = ({
  helmetProviderContext,
  pageMetaContextProviderValue,
  apolloProviderClient,
  i18n,
  auth,
  flagOverrides,
  analyticsUserData,
}) => {
  return (
    <AuthContext.Provider
      value={{
        ...auth,
        loggedOutGuid: analyticsUserData.logged_out_guid,
        loggedInGuid: analyticsUserData.logged_in_guid,
      }}
    >
      <FlagsProvider value={{ ...config.flags, ...(flagOverrides ?? {}) }}>
        <HelmetProvider context={helmetProviderContext}>
          <PageMetaContextProvider value={pageMetaContextProviderValue}>
            <ApolloProvider client={apolloProviderClient}>
              <CustomOptimizelyProvider>
                <ExperimentContext.Provider
                  value={{
                    abServiceUrl: config.abApiUrl,
                    analyticsCookieName: config.analyticsCookieName,
                  }}
                >
                  <App i18n={i18n} />
                </ExperimentContext.Provider>
              </CustomOptimizelyProvider>
            </ApolloProvider>
          </PageMetaContextProvider>
        </HelmetProvider>
      </FlagsProvider>
    </AuthContext.Provider>
  );
};

export default AppWithProviders;
